export default "__VITE_ASSET__CEGUAq9___"